@if (outboundFax.inboundFaxes.length > 0) {
  <div>
    Yes -
    <br />
    @for (inboundFax of outboundFax.inboundFaxes; track inboundFax) {
      <div>
        {{ inboundFax.status | faxStatus }}:
        @if (inboundFax.status === inboundFaxStatuses.notValidEvidence) {
          <span>{{ inboundFax.statusReason | capitalize }}</span>
        }
        <a target="_blank" routerLink="/capture-admin/consult-notes/{{ inboundFax.patientAttachmentId }}">
          {{ inboundFax.receivedAt | date: 'M/d/yyyy' }}
        </a>
      </div>
    }
  </div>
} @else {
  No
}

